<template>
  <OtivoButton
    v-if='isItSunsuperemployees'
    v-tooltip="{ content: 'Speak to a member of our Sunsuper Advice Team' }" colour='white' class='w-full'
    @click='addGoogleTag()'> Get Advice
  </OtivoButton>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'
import { useSessionStore } from '@/store/pinia/SessionStore'
import OtivoButton from '@/components/OtivoButton.vue'

// Composables
const sessionStore = useSessionStore()
const instance = getCurrentInstance()

// Computed properties (replacing Vuex mapGetters)
const isItSunsuperemployees = computed(() => sessionStore.getWhitelabelData.identifier === 'SUNSUPER_EMPLOYEES')

// Methods
const addGoogleTag = (): void => {
  location.href = 'mailto:advice@sunsuper.com.au'
  if (instance?.appContext.config.globalProperties.$gtag) {
    instance.appContext.config.globalProperties.$gtag.event('ContactAdvisor', { method: 'staffbenefits' })
  }
}
</script>

<style scoped></style>
